import { render, staticRenderFns } from "./OptionTargetFamilyTable.vue?vue&type=template&id=e725d7ee&lang=pug"
import script from "./OptionTargetFamilyTable.vue?vue&type=script&lang=ts"
export * from "./OptionTargetFamilyTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports